import { render, staticRenderFns } from "./ReverseTab.vue?vue&type=template&id=1b747fd8&"
import script from "./ReverseTab.vue?vue&type=script&lang=js&"
export * from "./ReverseTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports